import uni from "../styles/univesal.module.css";
import { header, logo } from "./common";
import { LangIds, Languages, getLang } from "../langs/langs";
import Lottie from "lottie-react";
import lottie_vertical from "../animations/F2-phone-vertical.json";

interface Props {
  lang: Languages;
  headerNum: String;
  onClick: () => void;
}

function Selfie({lang, headerNum, onClick}: Props) {
  return (
    <>
    <div className={uni.container}>
      {header(getLang(LangIds.SELFIE_Header, lang), headerNum)}
      <div className={uni.innerSmallCenterContainer}>
        <div className={uni.spacer}/>
        <div className={uni.bigText}>{getLang(LangIds.SELFIE_Name, lang)}</div>
        <div className={uni.spacerExtra}/>
        <div className={uni.center}>
          <Lottie className={uni.animationContainer} animationData={lottie_vertical}/>
        </div>
        <div className={uni.spacerBig}/>
        <div className={uni.spacerSmall}/>
        <div className={uni.mediumText}><b>{getLang(LangIds.SELFIE_Desc1, lang)}</b>{getLang(LangIds.SELFIE_Desc2, lang)}</div>
      </div>
      <div className={uni.filler}/>
      <div className={uni.innerSmallCenterContainer}>
        <button className={uni.button} type="button" onClick={onClick}>{getLang(LangIds.SELFIE_Take, lang)}</button>
        {logo(getLang(LangIds.LOGO_Powered, lang))}
      </div>
    </div>
    </>
  );
}

export default Selfie;
